import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import ConfirmDialog from 'components/confirm-dialog';
import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { ProductWizardStep } from 'pages/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'pages/menu/components/product-wizard/use-product-wizard-flow';

import { BodyComponent } from '../body-component';

export const CloseConfirmationDialog = () => {
  const { formatMessage } = useIntl();
  const { closeWizard, currentFlowStep } = useProductWizardFlow();

  const {
    showCloseDialog,
    setShowCloseDialog,
    restoreSlotsSelectionSnapshot,
  } = useProductWizardContext();
  const heading = formatMessage({ id: 'productDetailCloseHeading' });
  const content = formatMessage({ id: 'productDetailCloseContent' });

  const confirmLabel = formatMessage({ id: 'leaveNow' });
  const cancelLabel = formatMessage({ id: 'continueCustomizing' });
  const shouldShowDialog =
    showCloseDialog && currentFlowStep.step !== ProductWizardStep.ProductCustomization;

  const onConfirm = useCallback(() => {
    restoreSlotsSelectionSnapshot();
    setShowCloseDialog(false);
    closeWizard();
  }, [restoreSlotsSelectionSnapshot, closeWizard, setShowCloseDialog]);

  const onCancel = useCallback(() => {
    setShowCloseDialog(false);
  }, [setShowCloseDialog]);

  return (
    <ConfirmDialog
      showDialog={shouldShowDialog}
      modalAppearanceEventMessage="Product Detail Close Dialog"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
